module.exports = __webpack_public_path__ + "img/project-8.00f612fb.jpg";